import React, { useState } from "react";
import { InputBox, SubmitButton, TextAreaBox } from "../../components/Input";

// Add More Section Component (for dynamic input fields)
const AddMoreSection = ({ index, handleRemove }) => {
  const [title, setTitle] = useState("");
  const [fileName, setFileName] = useState("");
  const [details, setDetails] = useState("");

  return (
    <div className="panel-body" id={`box_${index}`}>
      <div className="row">
        <div className="col-md-4">
          <InputBox
            label="Title"
            fieldname={`title_${index}`}
            placeholder="Enter Title"
            value={fileName}
            onChange={(e) => setFileName(e.target.value)}
          />
        </div>
        <div className="col-md-4">
          <InputBox
            label="File Name"
            fieldname={`filename_${index}`}
            placeholder="Enter File Name"
            value={fileName}
            onChange={(e) => setFileName(e.target.value)}
          />
        </div>
        <div className="col-md-1">
          <button
            type="button"
            className="btn btn-danger"
            style={{ marginTop: "26px" }}
            onClick={() => handleRemove(index)}
          >
            <i className="fa fa-cross"></i> X Delete
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <TextAreaBox
            label="Details"
            fieldname={`details_${index}`}
            placeholder="Enter Details"
            value={details}
            onChange={(e) => setDetails(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

// Main Add Page Component
const PageAdd = () => {
  const [sections, setSections] = useState([{ index: 1 }]);
  const [formData, setFormData] = useState({
    pageName: "",
    id: "",
  });

  const handleAddMore = () => {
    const newIndex = sections.length + 1;
    setSections([...sections, { index: newIndex }]);
  };

  const handleRemove = (indexToRemove) => {
    setSections(sections.filter(({ index }) => index !== indexToRemove));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here (e.g., call API to save data)
    console.log("Form Data:", formData);
  };

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="panel-heading border-0">
            <span className="panel-title">Add Pages</span>
          </div>
          <div className="panel-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <InputBox
                    label="Page Name"
                    fieldname="pageName"
                    placeholder="Enter Page Name"
                    value={formData.pageName}
                    onChange={(e) =>
                      setFormData({ ...formData, pageName: e.target.value })
                    }
                  />
                </div>
              </div>
              {sections.map(({ index }) => (
                <AddMoreSection
                  key={index}
                  index={index}
                  handleRemove={handleRemove}
                />
              ))}
              <div className="panel-body">
                <div className="col-md-12">
                  <div className="form-group">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={handleAddMore}
                    >
                      Add More
                    </button>
                  </div>
                </div>
                <div className="col-md-12">
                  
                  <SubmitButton/>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageAdd;
